import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import SeoHead from '@/components/feature/SeoHead';
import BackToTop from '@/components/feature/BackToTop';
import Hero from '@/pages/home/components/Hero';
import QuickChannels from '@/pages/home/components/QuickChannels';
import MissionSection from '@/pages/home/components/MissionSection';
import HighlightsSection from '@/pages/home/components/HighlightsSection';
import ProcessSection from '@/pages/home/components/ProcessSection';
import AccountsSection from '@/pages/home/components/AccountsSection';
import FaqSection from '@/pages/home/components/FaqSection';
import CtaBand from '@/pages/home/components/CtaBand';
import { homeFaqs } from '@/mocks/siteData';

const homeStructuredData = [
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '深瞳爆料',
    url: 'https://shentong-baoliao.com/',
    email: 'contact@shentong-baoliao.com',
    description:
      '深瞳爆料是一个以信源保护为优先的调查线索汇集平台，通过官方邮箱与匿名通道接收公众线索。',
    contactPoint: [
      {
        '@type': 'ContactPoint',
        contactType: '线索投稿',
        email: 'xiansuo@shentong-baoliao.com',
        availableLanguage: ['zh-CN'],
      },
      {
        '@type': 'ContactPoint',
        contactType: '商务合作',
        email: 'business@shentong-baoliao.com',
        availableLanguage: ['zh-CN'],
      },
    ],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '深瞳爆料官网',
    url: 'https://shentong-baoliao.com/',
    inLanguage: 'zh-CN',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://shentong-baoliao.com/contact?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '深瞳爆料官网｜联系方式_商务合作_投稿邮箱_官方账号',
    url: 'https://shentong-baoliao.com/',
    description:
      '深瞳爆料官网官方联系渠道汇总，提供投稿邮箱、商务合作方式、官方账号信息与匿名线索提交入口。',
    inLanguage: 'zh-CN',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: homeFaqs.map((faq) => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: { '@type': 'Answer', text: faq.a },
    })),
  },
];

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <SeoHead
        title="深瞳爆料官网｜联系方式_商务合作_投稿邮箱_官方账号"
        description="深瞳爆料官网官方联系渠道汇总，提供投稿邮箱、商务合作方式、官方账号信息与匿名线索提交入口，方便用户与平台直接沟通，共建可信的爆料社区。"
        keywords="爆料官网,联系方式,商务合作,投稿邮箱,官方账号"
        path="/"
        structuredData={homeStructuredData}
      />
      <SiteHeader />
      <main className="flex-1">
        <Hero />
        <QuickChannels />
        <MissionSection />
        <HighlightsSection />
        <ProcessSection />
        <AccountsSection />
        <FaqSection />
        <CtaBand />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}